const TaxSummaryGroup = require('@/lib/Tax/TaxSummaryGroup');
const { toIntArray } = require('@/functions/transform');

/**
 * Represents the tax for a single line in an order/booking.
 */
class LineTaxSummary {
    constructor() {
        /**
         * The line IDs(s) this tax applies to.
         * This is an array because when getting the tax for a booking (which can include adjustments) multiple
         * different line IDs may be in play for one line, due to the line being adjusted and replaced.
         *
         * @type {number[]}
         */
        this.ordersItemsIDs = [];

        /**
         * @type {TaxSummaryGroup[]}
         */
        this.taxSummaryGroups = [];

        /**
         * The list of tax summary groups re-grouped only by the taxRate.
         *
         * @type {TaxSummaryGroup[]}
         */
        this.taxSummaryGroupsByTaxRate = [];
    }

    getHydrationMap() {
        return {
            ordersItemsIDs: toIntArray,
            taxSummaryGroups: {
                // The array of groups is just called taxSummary from the API.
                field: ['taxSummaryGroups', 'taxSummary'],
                modelCollection: TaxSummaryGroup,
            },
        };
    }
}

module.exports = LineTaxSummary;
